import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/home/ubuntu/html/tablespace-website/components/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/home/ubuntu/html/tablespace-website/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/html/tablespace-website/components/Motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/html/tablespace-website/node_modules/next/dist/client/app-dir/link.js");
